<template>
	<div class="page">
		<top-header></top-header>

		<b-container fluid style="margin-top: 5%;">
			<b-row class="mt-4 mb-2  px-3 text-white" >
					<b-col class="col-md-6 col-sm-6 col-xs-6">
						<h4>Led Driver Stock History | <small>Supervisor: {{supervisorName}}</small></h4>
					</b-col>
					<b-col class="col-md-3 col-sm-6 col-xs-6 text-right">
						
						
					</b-col>
					<b-col class="col-md-3 col-sm-6 col-xs-6 text-right">
						<!-- <b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF()">Download PDF</b-button> -->
						<b-button variant="dark" pill size="sm"  @click="downloadCSV()">Download CSV</b-button>
						
					</b-col>
				</b-row>
			
			
		</b-container>
		
			
		<b-container fluid >
			<div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">
				
				<b-row>
					<b-col class="col-md-12 col-sm-12 col-xs-12 ">
						
							<b-row class="mt-4 px-3 mb-3">
								<b-col lg="6">
									<label class="mr-2">Show</label>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="12">
									

									<b-table
									show-empty
									sticky-header
									responsive
									outlined
									caption-top
									hover
									head-variant="dark"
									borderless="borderless"
									id="my-table-live"
									stacked="md"
									stickyColumn="scrolled"
							
									:items="recordsTop"                  
									:fields="fields"
									:current-page="currentPage"
									:per-page="perPage"
									:filter="filter"
									:filterIncludedFields="filterOn"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
									:sort-direction="sortDirection"
									@filtered="onFiltered"
									class="scrollH d-flex" 
								>

									<template #cell(data)="row">
									<!-- {{ row.item.data}} -->
										<b-table :items="row.item.data" :fields="fields_data"></b-table> 
										
									</template> 
									</b-table>
								</b-col>
							</b-row>
							
							<b-row class="px-3 mb-3">
								<b-col lg="6">
									<span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{recordsTop.length}} entries</span>
								</b-col>
								<b-col lg="6">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						
					</b-col>
				</b-row>
			</div>
		</b-container>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";


export default {
	name: 'Devices Record',
	components: {
		"top-header": Header,		
		
	},
	beforeDestroy(){
		//console.log("CLEAR INTERVAL DASHBOARD");	
		window.removeEventListener("scroll", this.onScroll, true)
	},
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			url: self.$session.get('apiurl')+'inventoryapi/driverstock-history',
			supervisorId: self.$route.params.supervisorId,
			supervisorName:'',
			records: [],
			device: {},
			firstRecord:[],
      recordsTop: [],
      fields: [{
                text: 'Data1',
                value: 'data'
            },{
                text: 'InsertTime',
                value: 'insert_time'
            }],

      fields_data: [
          { key: "device_id", label: "" }
                            
      ],

			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
      		//fieldattributList:['Quantity','Warranty','Brand','Vendor'],
	  		fieldattributList:['Quantity','Warranty','Brand'],
     
		};
	},
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key'),
				supervisorId: self.supervisorId
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
          var recordsTopvar = response.data.result.records;
          var ledVendors  = response.data.result.led_vendors;
          var ledBands  = response.data.result.led_brands;


          
					
					self.loading = false;
					if(self.records.length>0){
					self.totalRows = self.records.length;
					self.device = response.data.result.device;					
					self.supervisorName	 = self.records[0].username; 	
					}		
					self.firstRecord =self.records[0];
         // self.recordsTop = response.data.result.records;


         

         /* ======= Push Light Wart Header ======= */        
          self.$root.wattslight.forEach(function(date) {   
          self.fields_data.push({ key: 'w'+date, label: "W"+date, variant: "secondary", class: "text-center"});
          });

          self.recordsTop=[];
          recordsTopvar.forEach(function(element){
              var fettingData  ={};
              var vanderData   ={};
              var warrantyData ={};
              var brandData    ={};   
              if(element.led_fittings!=null && element.led_fittings!=''){
                fettingData  =JSON.parse(element.led_fittings);
              }
              if(element.led_vendor!=null && element.led_vendor!=''){
                vanderData   = JSON.parse(element.led_vendor);
              }
              if(element.led_warranty!=null && element.led_warranty!=''){
                warrantyData = JSON.parse(element.led_warranty);
              }
              if(element.led_brand!=null && element.led_brand!=''){
                brandData    =JSON.parse(element.led_brand);  
              }            
                var dataInner =[];               
                self.fieldattributList.forEach(function(attr){
                  var dataVal ={};
                  dataVal['device_id']=attr;
                  self.$root.wattslight.forEach(function(wno) {  
                     var wt ='w'+wno; 
                      var wval =''; 
                      switch(attr) {
                        case 'Quantity':
                         
                          wval = fettingData[wt]>0?fettingData[wt]:0;
                        break;
                        case 'Warranty':
                          var warrt ='warranty'+wno;                           
                          wval = warrantyData[warrt]!='' && warrantyData[warrt]!=undefined?warrantyData[warrt]:'---';  
                         break;
                        case 'Brand':
                          var wbart ='brand'+wno;                           
                         var brandId = brandData[wbart]!=''?brandData[wbart]:0; 

                          var wbranArr =  ledBands.filter(function (item) {
                            return item.id == brandId
                           });

                           if(wbranArr.length>0){
                            wbranArr = wbranArr[0].brand_name;
                           }else{
                            wbranArr ='---';
                           }                          
                           wval = wbranArr;  
                          
                          


                        break;
                        case 'Vendor':
                          var wvandt ='vendor'+wno;   

                          var vanderId = vanderData[wvandt]!=''?vanderData[wvandt]:'0';                            
                          var wvalArr =  ledVendors.filter(function (item) {
                            return item.id == vanderId
                           });
                           if(wvalArr.length>0){
                            wvalArr = wvalArr[0].vendor_name;
                           }else{
                            wvalArr ='---';
                           }                          
                           wval = wvalArr;       
                        break;
                        default:
                        wval = '';
                      }
                      dataVal[wt]=wval;

                  });                 
                  dataInner.push(dataVal);
                  //dataInner.push({ device_id: attr, w20: 40, w35: 'Dickerson', w45: 'Macdonald' });
                  
                })
              var rectodTopIN ={data:dataInner,insert_date:element.update_time}
              self.recordsTop.push(rectodTopIN);
               
          });					
					
					setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		convertToCSV(jsonData) {
				var userInfoText = ['Led Driver Stock History | Supervisor: ' + this.supervisorName];
				let totalColumns = 13;
				const userInfoRow = [userInfoText, ...Array(totalColumns - 1).fill('')];

				const header = ['Date', 'Device Type', ...this.$root.wattslight.map(w => `W${w}`)];

				let csv = [userInfoRow];
				csv.push(['']);
				csv.push(header);
				//let csv = [header]; // Start with header row
				
				jsonData.forEach(item => { 
				const date = item.insert_date;
				
				// Process each device type (Quantity, Warranty, Brand)
					item.data.forEach(device => {
						const deviceType = device.device_id;
						const row = [date, deviceType];
						
						// Add wattage values
						this.$root.wattslight.forEach(watt => {
						row.push(device[`w${watt}`] || '');
						});
						
						csv.push(row);
					});
				
				// Add an empty row after each date's device types
				csv.push(['', '', ...Array(this.$root.wattslight.length).fill('')]);
				});			
				return csv.map(row => row.join(',')).join('\n');
			},

		downloadCSV() {
		const csvContent = this.convertToCSV(this.recordsTop);
		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		const url = URL.createObjectURL(blob);
		
		link.setAttribute('href', url);
		link.setAttribute('download', 'led_driver_stock_history.csv');
		link.style.visibility = 'hidden';
		
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		},
		onChangeEventHandler(imei,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei = imei;
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));			
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser', o);
			}
			this.initload();
		},
		onChangeEventPhaseHandler(imei,phase,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei 	= imei; 
			o.phase = phase; 
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));
			console.log('asdasd');
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser_phase', o);
			}
			this.initload();
		},
	}
}
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-image: url(../../assets/home-banner.png) !important;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-position: center center; */
  background-position: bottom;
}

.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}
#my-table-live .thead-dark th {
  color: #fff;
  background-color: #ff9a37;
  border-color: #ff9a37;
}
#my-table-live .first-col {
  border-radius: 20px 0px 0px 0px;
  min-width: 130px;
}
#my-table-live .last-cal {
  border-radius: 0px 20px 0px 0px;
  min-width: 153px;
}
.borderRadius20 {
  border-radius: 20px;
}
.table-responsive {
  border-radius: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
.w-15{
	width: 15%;
}
.w-10{
	width: 10%;
}
.w-20{
	width: 20%;
}
.h-10{
	height: 10px !important;
}
.h-15{
	height: 15px !important;
}
.h-20{
	height: 20px !important;
}


.v-select{
    width:auto ;
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
    padding: 0px;
    border: 0px;

}

.v-select-toggle {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem !important;
}

.v-select .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none;
    width: auto;
}
.customselectfilter button{
  height: 36px;
}

.tbl-header{
  background: #c6c6c6;
    padding: 6px;
    margin-bottom: 5px;
    text-align: center;
    font-weight: 700;
}
</style>